import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ConsultasService } from '@app/services/consultas.service';
import { RelatorioService } from '@app/services/relatorio.service';
import { UtilitarioService } from '@app/services/utilitario.service';
import { CDSMask } from '@app/utils/cds-mask';

import { FiltroFaturamentoPorTipoAcao } from './filtro-faturamento-por-tipo-acao';
import { ToastrService } from 'ngx-toastr';
import { FaturamentoTipoAcao } from '@app/models/relatorio-faturamento-tipo-acao';
import { KeyValue } from '@angular/common';
import { CsvGeneratorService } from '@app/services/csv-generator.service';

@Component({
  selector: 'app-faturamento-por-tipo-acao',
  templateUrl: './faturamento-por-tipo-acao.component.html',
  styleUrls: ['./faturamento-por-tipo-acao.component.scss']
})
export class FaturamentoPorTipoAcaoComponent implements OnInit {

  cdsMask: CDSMask = new CDSMask();
  filtros: FiltroFaturamentoPorTipoAcao = new FiltroFaturamentoPorTipoAcao();

  lstTipoProcesso: IdDescricao[] = [];
  listaAnos: IdDescricao[] = [];
  complementoTitulo: string = "";

  relatorioFaturamento: FaturamentoTipoAcao[] = [];

  pesquisando: boolean;
  showTable: boolean = false;
  dataRelatorio: Date;

  _debounce: any;
  _pesquisa: any;

  ordenarPorChave = (a: KeyValue<number,number>, b: KeyValue<number,number>): number => {
    return a.key - b.key;
  }

  constructor(
    private relatorioService: RelatorioService,
    private consultasService: ConsultasService,
    private csvService: CsvGeneratorService,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this._preencherAnos();
    this.consultasService.consultar('TIPODEACAO').toPromise().then(data => this.lstTipoProcesso = data);
  }

  private _preencherAnos() {
    // 2023→2008
    this.listaAnos.length = 0;
    let ano = Number.parseInt(this.filtros.AnoSelecionado);
    
    do {
      this._adicionaAno(ano);
      ano--;
    } while (ano >= 2008); //o primeiro ano que encontrei no banco foi 2008
  }

  private _adicionaAno(adicionaAno: number): void {
    let anoOpcao: IdDescricao = new IdDescricao();
    anoOpcao.Id = adicionaAno;
    anoOpcao.Descricao = adicionaAno.toString();
    
    this.listaAnos.push(anoOpcao);
  }

  pesquisar() {
    this.dataRelatorio = new Date();
    this.pesquisando = true;
    let nomeTipoProcesso = this.lstTipoProcesso.filter(x => x.Id == this.filtros.TipoDeAcaoId)[0].Descricao;
    this.complementoTitulo = `(${nomeTipoProcesso}/${this.filtros.AnoSelecionado})`;

    this.relatorioService.faturamentoPorTipoDeAcao(this.filtros)
      .toPromise().then((dados:FaturamentoTipoAcao[]) => {
        this.relatorioFaturamento = dados;
        this.pesquisando = false;

        if (this.relatorioFaturamento.length === 0) {
          this.toastr.info("Busca não encontrou resultados");
          this.showTable = false;
        } else {
          this.showTable = true;
          // this._calculaTotais();
        }
      },
        () => {
          this.pesquisando = false
          this.toastr.warning("Realize a pesquisa novamente.")
        }
      );
  }

  baixarCsv() {
    const titulo = `Faturamento Anual ${this.complementoTitulo}`;
    const nomeArquivo = `Faturamento_Anual${this.complementoTitulo}`;
    const header = [
      "Unidade", "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro", "Total Anual"
    ];
  
    const csvFaturamento = this.relatorioFaturamento.map(item => ({
      Unidade: item.Unidade,
      Janeiro: this.formatarValor(item.JaneiroValor),
      Fevereiro: this.formatarValor(item.FevereiroValor),
      Março: this.formatarValor(item.MarcoValor),
      Abril: this.formatarValor(item.AbrilValor),
      Maio: this.formatarValor(item.MaioValor),
      Junho: this.formatarValor(item.JunhoValor),
      Julho: this.formatarValor(item.JulhoValor),
      Agosto: this.formatarValor(item.AgostoValor),
      Setembro: this.formatarValor(item.SetembroValor),
      Outubro: this.formatarValor(item.OutubroValor),
      Novembro: this.formatarValor(item.NovembroValor),
      Dezembro: this.formatarValor(item.DezembroValor),
      "Total Anual": this.formatarValor(item.TotalAnual)
    }));
  
    this.csvService.downloadCSV(csvFaturamento, header, nomeArquivo, titulo);
  }
  
  private formatarValor(valor: number): string {
    return `R$ ${valor.toFixed(2).replace('.', ',')}`;
  }
  
  @ViewChild('relatorioFaturamentoTipoAcao') relatorioFaturamentoTipoAcao: ElementRef;
  public imprimir() {
    let conteudo = document.getElementById("relatorioFaturamentoTipoAcao").innerHTML;
    UtilitarioService.imprimirHTML(
      conteudo,
      `Faturamento Anual ${this.complementoTitulo}`,
      this.montaImpressaoFiltros()
    );
  }

  private montaImpressaoFiltros(){
    let objetoFiltros = new Map<string, string>();

    adicionaMapValido('Ano', this.filtros.AnoSelecionado);
    obtemDescricaoAdicionaMap('Tipo de Ação', this.lstTipoProcesso, this.filtros.TipoDeAcaoId);
    adicionaMapValido('Emitido em', this.dataRelatorio.toLocaleString());
    
    let stringHtml = '';
    objetoFiltros.forEach((valor, chave) => {
      stringHtml += `<tr><td>${chave}</td><td>${valor}</td></tr>`;
    });
    return stringHtml;

    // Funções internas
    function obtemDescricaoAdicionaMap(chave: string, listaItens: IdDescricao[], idItem: number){
      if(idItem){
        let valor = listaItens.find(x => x.Id === idItem).Descricao;
        objetoFiltros.set(chave, valor);
      } 
    }

    function adicionaMapValido(chave: string, valor: any){
      if(valor){
        objetoFiltros.set(chave, valor.toString());
      }
    }
  }
}
